var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-card', [_c('b-overlay', {
    attrs: {
      "show": _vm.isLoading,
      "rounded": "sm"
    }
  }, [_c('h4', {
    staticClass: "font-weight-bold mb-4"
  }, [_vm._v(" " + _vm._s(_vm.isEdit ? "編輯聯絡人" : "新增聯絡人") + " ")]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "聯絡人姓名"
    }
  }, [_c('b-form-input', {
    attrs: {
      "state": _vm.nameState
    },
    model: {
      value: _vm.contact.name,
      callback: function callback($$v) {
        _vm.$set(_vm.contact, "name", $$v);
      },
      expression: "contact.name"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": _vm.nameState
    }
  }, [_vm._v(" 請輸入聯絡人姓名 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "關係"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.contact.relationship,
      callback: function callback($$v) {
        _vm.$set(_vm.contact, "relationship", $$v);
      },
      expression: "contact.relationship"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "手機號碼"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.contact.mobile_phone,
      callback: function callback($$v) {
        _vm.$set(_vm.contact, "mobile_phone", $$v);
      },
      expression: "contact.mobile_phone"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "生日"
    }
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "選擇日期",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "clear-button": ""
    },
    model: {
      value: _vm.birthday,
      callback: function callback($$v) {
        _vm.birthday = $$v;
      },
      expression: "birthday"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "性別"
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "options": _vm.sexualOptions,
      "value-field": "value",
      "text-field": "text"
    },
    model: {
      value: _vm.contact.sexual,
      callback: function callback($$v) {
        _vm.$set(_vm.contact, "sexual", $$v);
      },
      expression: "contact.sexual"
    }
  })], 1), _c('div', {
    staticClass: "d-flex justify-content-center mt-4"
  }, [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "outline-secondary",
      "to": {
        name: 'CustomerContactList',
        params: {
          customerID: _vm.customerID
        }
      }
    }
  }, [_vm._v(" 取消 ")]), _c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(" 儲存 ")])], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }